import {
  type DehydrateOptions,
  QueryClient,
  dehydrate,
} from "@tanstack/react-query";

export const customDehydrate = (
  client: QueryClient,
  options?: DehydrateOptions,
) => {
  // Meta is now included on the dehydrated state, so we need to remove it
  let dehydrated = dehydrate(client, options);
  dehydrated = {
    mutations: dehydrated.mutations,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    queries: dehydrated.queries.map(({ meta, ...query }) => query),
  };

  return dehydrated;
};
